import { CONFIG_COURSE } from '@vedalib/editor/lib/elements'
import type { AutoHideBehavior, Options } from 'overlayscrollbars'
import type React from 'react'
import { useMemo } from 'react'

import { validateBoxShadowCss } from 'services/Branding/components/BrandFieldShadow/validateBoxShadowCss'
import { useElementStyleValues } from 'services/Branding/hooks'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getDeviceMode } from 'services/Store/Project/selectors'

export const useScrollbarProps = () => {
  const deviceMode = useProjectContext(getDeviceMode)
  const values = useElementStyleValues(CONFIG_COURSE.scrollbar.type, deviceMode)

  return useMemo(
    () => ({
      className: 'os-host-flexbox',
      options: {
        scrollbars: { autoHide: values.scrollbar.visibility as AutoHideBehavior },
        sizeAutoCapable: false,
      } satisfies Options,
      style: {
        '--course-sb-display': values.scrollbar.visibility === 'hide' ? 'none' : 'block',
        '--course-sb-width': `${values.scrollbar.width}px`,
        '--course-sb-color': values.scrollbar.color,
        '--course-sb-hover-color': values.scrollbar.hoverColor,
        '--course-sb-radius': `${values.scrollbar.borderRadius}px`,
        '--course-sb-border-style': `${values.scrollbar.borderStyle || 'none'}`,
        '--course-sb-border-width': `${values.scrollbar.borderWidth}px`,
        '--course-sb-border-color': values.scrollbar.borderColor,
        '--course-sb-shadow': validateBoxShadowCss(values.effects?.boxShadow) || 'none',
      } as React.CSSProperties,
    }),
    [values],
  )
}
